import { useContext, useMemo } from 'react'
import { ModelService } from '../services/ModelService'
import { StoreContext } from '../services/Store'
import { BaseSchema } from '../helpers/BaseSchema'

// Get the current store from context, and return the model matching the provided schema object
export const useModel = <T extends BaseSchema>(schema: (new () => T)) => {
  const store = useContext(StoreContext)
  if (store === null || store === undefined) { throw new Error('No Store Context available - make sure you add a DB store to use') }

  const model = useMemo(() => store.getModel(schema), [schema, store])
  return model as ModelService<T>
}
